module.exports = __webpack_public_path__ + "img/move.e4bbb50b.png";